

























import { defineComponent } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { GameContractModel } from './model';

export default defineComponent({
    props: {
        appId: {
            type: String,
            default: '',
        },
    },
    setup(props, context) {
        const model = useApolloModel(GameContractModel);
        return { model };
    },
});
